export default "__VITE_ASSET__CfyMDzG0__"